"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InkEffect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const InkEffect = ({ children, ...props }) => {
    const ref = (0, react_1.useRef)(null);
    const handleClick = (e) => {
        if (ref.current) {
            const rect = ref.current.getBoundingClientRect();
            ref.current.style.setProperty('--x', `${e.clientX - rect.left}px`);
            ref.current.style.setProperty('--y', `${e.clientY - rect.top}px`);
            ref.current.classList.add('active');
            setTimeout(() => ref.current?.classList.remove('active'), 600);
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { ref: ref, className: "ink-effect", onClick: handleClick, ...props, children: children }));
};
exports.InkEffect = InkEffect;
